import { AuthContext } from 'context'
import { useAuthentication } from 'hooks/useAuthentication'
// import useNewWikiNewsNotification from 'hooks/useNewWikiNewsNotification'
import * as React from 'react'

const GlobalContextProvider: React.FunctionComponent = ({ children }) => {
  const authentication = useAuthentication()
  // const {
  //   modifiedNewsCounter,
  //   modifiedWikisCounter,
  //   setRefetchFlag,
  // } = useNewWikiNewsNotification()

  return (
    <AuthContext.Provider value={authentication}>
      {/* <NewNewsContext.Provider
        value={{
          newNewsCount: modifiedNewsCounter,
          setRefetchFlag,
        }}
      >
        <NewWikisContext.Provider
          value={{
            newWikiCount: modifiedWikisCounter,
            setRefetchFlag,
          }}
        > */}
      {children}
      {/* </NewWikisContext.Provider> */}
      {/* </NewNewsContext.Provider> */}
    </AuthContext.Provider>
  )
}

export default GlobalContextProvider
